import React, { useState, useEffect } from 'react';
import {
  Stack,
  InputLabel,
  Button,
  TextField,
  Alert,
  Grid,
} from '@mui/material';

// NETWORKING
import useAddressBookRequest from '../../../../requests/AddressBookRequest';

// FORMATTED MESSAGES
import AddressBookFormattedMessages from '../../../../messages/websms/AddressBookFormattedMessages';

const GlobalBlackListSingle = ({ backFunction, selected, errorHandler }) => {
  const [formFields, setFormFields] = useState({
    number: selected ? selected.number : '',
    email: selected ? selected.email : '',
  });
  const [saving, setSave] = useState(false);
  const [error, setError] = useState('');
  const { updateBlacklistGlobal, insertBlacklistGlobal } =
    useAddressBookRequest();

  useEffect(() => {
    if (selected) {
      setFormFields({
        number: selected.number,
        email: selected.email,
      });
    }
  }, [selected]);

  const handleChangeEvent = (event) => {
    const target = event.target;
    const name = target.name;
    let value = target.value;

    if (name === 'email') {
      value = value.toLowerCase();
    }

    setFormFields({
      ...formFields,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    if (!saving) {
      const { number, email } = formFields;

      if (!number) {
        return setError('Contact Number is required');
      }

      if (!email) {
        return setError('Email Address is required');
      }

      setSave(true);
      setError('');

      let response;
      if (selected) {
        response = await updateBlacklistGlobal(
          selected.blacklist_id,
          formFields,
          errorHandler
        );
      } else {
        response = await insertBlacklistGlobal(formFields, errorHandler);
      }

      setSave(false);
      if (!response?.error) {
        backFunction(true);
      }
    }
  };

  const handleButtonGroup = () => {
    return (
      <Stack sx={{ flexDirection: 'row', gap: 2, justifyContent: 'end' }}>
        <Button variant="link" color="secondary" onClick={backFunction}>
          {AddressBookFormattedMessages.cancelText}
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          disabled={saving || !formFields.number || !formFields.email}
        >
          {saving
            ? AddressBookFormattedMessages.saving
            : AddressBookFormattedMessages.save}
        </Button>
      </Stack>
    );
  };

  const generateError = () => {
    if (error) {
      return <Alert severity="error">{error}</Alert>;
    }
    return null;
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Stack
          sx={{
            flexDirection: { md: 'row' },
            alignItems: { md: 'center' },
            gap: { md: 2 },
          }}
        >
          <InputLabel sx={{ minWidth: 150 }} required>
            Contact Number
          </InputLabel>

          <TextField
            name="number"
            value={formFields.number}
            onChange={handleChangeEvent}
            fullWidth
            variant="outlined"
            required
            size="small"
          />
        </Stack>
      </Grid>

      <Grid size={12}>
        <Stack
          sx={{
            flexDirection: { md: 'row' },
            alignItems: { md: 'center' },
            gap: { md: 2 },
          }}
        >
          <InputLabel sx={{ minWidth: 150 }} required>
            Email Address
          </InputLabel>

          <TextField
            name="email"
            value={formFields.email}
            onChange={handleChangeEvent}
            fullWidth
            variant="outlined"
            required
            size="small"
          />
        </Stack>
      </Grid>
      <Grid size={12}>{generateError()}</Grid>
      <Grid size={12}>{handleButtonGroup()}</Grid>
    </Grid>
  );
};

export default GlobalBlackListSingle;
